// ----------------- START PURCHASE SCRIPT ------------------------------------
// `breeze-purchase` event listener
window.addEventListener("breeze-purchase", (event) => {
  const eventData = event.detail;
  breezePurchase(eventData);
});

// This function will be invoked by breeze after purchase
function breezePurchase(payload) {
  try {
    merchantPurchaseCustomCode(payload.data);
  } catch (e) {
    console.log("Error in triggering merchants purchase script : ", e);
  }
}

// merchant script for `purchase` will be pasted here
function merchantPurchaseCustomCode(params) {

  // GOOGLE ADS PURCHASE EVENT CODE START
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    dataLayer.push(arguments);
  }
  gtag("js", new Date());
  gtag("config", "AW-11547938520");
  window.gtag("event", "conversion", {
    send_to: ["AW-11547938520/uGIVCJ3kmowaENidvoIr"],
    value: params.totalPrice,
    currency: "INR",
    transaction_id: params.shopOrderId,
    triggered_by: "breeze_purchase"
  });

    window.rdt('track', 'Purchase', {
    currency: 'INR',
    value: params.totalPrice,
    itemCount: params.items.reduce((total, item) => total + item.quantity, 0),
    conversionId: params.shopOrderId,
    products: params.items.map(item => ({
      id: item.id,
      name: item.name
    }))
  });

  // window.snaptr('track', 'Purchase', {
  //   currency: 'INR',
  //   value: params.totalPrice,
  //   itemCount: params.items.reduce((total, item) => total + item.quantity, 0),
  //   conversionId: params.shopOrderId,
  //   products: params.items.map(item => ({
  //     id: item.id,
  //     name: item.name
  //   }))
  // });

  // GOOGLE ADS PURCHASE EVENT CODE END
  
}

// ----------------- END PURCHASE SCRIPT --------------------------------------

// ----------------- START ADD_PAYMENT_INFO SCRIPT ----------------------------

// `breeze-add-payment-info` event listener
window.addEventListener("breeze-add-payment-info", (event) => {
  const eventData = event.detail;
  breezeAddPaymentInfo(eventData);
});

// This function will be invoked by breeze after add payment info
function breezeAddPaymentInfo(payload) {
  try {
    merchantAddPaymentInfoCustomCode(payload.data);
  } catch (e) {
    console.log("Error in triggering merchants add Payment info script : ", e);
  }
}

// merchant script for `add_payment_info` will be pasted here
function merchantAddPaymentInfoCustomCode(params) {
  console.error(">>>>>> hello ", params);
  // GOOGLE ADS ADD PAYMENT INFO EVENT CODE START
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    dataLayer.push(arguments);
  }
  gtag("js", new Date());
  gtag("config", "AW-11547938520");
  window.gtag("event", "conversion", {
    send_to: ["AW-11547938520/p5eQCN2k0pUaENidvoIr"],
    value: params.totalPrice,
    currency: "INR",
    transaction_id: params.shopOrderId,
    triggered_by: "breeze_checkout"
  });
  // GOOGLE ADS ADD PAYMENT INFO EVENT CODE END

  // window.snaptr('track', 'Begin_Checkout', {
  //   currency: 'INR',
  //   value: params.totalPrice,
  //   itemCount: params.items.reduce((total, item) => total + item.quantity, 0),
  //   conversionId: params.shopOrderId,
  //   products: params.items.map(item => ({
  //     id: item.id,
  //     name: item.name
  //   }))
  // });
  
}

// ----------------- END ADD_PAYMENT_INFO SCRIPT ------------------------------
